export default "__VITE_ASSET__fe0e2f24__"